/**
 * Whether a response status means "this server does not have the bulk stub
 * route" as opposed to "the request failed".
 *
 * 404 is the obvious case. 400 is the important one: a server without the
 * route matches /items/:itemId instead, fails to parse "stubs" as an integer,
 * and returns 400. Verified against the live duck region on 2026-09-03.
 */
export function isEndpointAbsent(status: number): boolean {
    return status === 404 || status === 400;
}
